export const INSIGHTS = [
  {
    slug: "ai-readiness-is-an-organizational-question",
    category: "AI Strategy & Adoption",
    title: "Why AI Readiness Is an Organizational Question, Not a Technical One",
    excerpt:
      "The organizations making real progress with AI are not the ones with the most tools—they are the ones that aligned strategy, leadership, governance, and people first.",
    readTime: "6 min read",
    placeholder: true,
  },
  {
    slug: "five-conditions-pilot-to-practice",
    category: "AI Strategy & Adoption",
    title: "Five Conditions for Moving AI From Pilot to Practice",
    excerpt:
      "Pilots are easy to start and hard to scale. A handful of organizational conditions separate experimentation from enterprise adoption.",
    readTime: "7 min read",
    placeholder: true,
  },
  {
    slug: "questions-before-approving-an-ai-roadmap",
    category: "Executive Advisory",
    title: "What Presidents and Boards Should Ask Before Approving an AI Roadmap",
    excerpt:
      "A roadmap full of use cases is not a strategy. The questions to answer before committing institutional resources.",
    readTime: "5 min read",
    placeholder: true,
  },
  {
    slug: "the-sponsors-role-in-transformation",
    category: "Organizational Transformation",
    title: "Leading Through Uncertainty: The Sponsor's Role in Transformation",
    excerpt:
      "Active sponsorship is one of the most reliable predictors of transformation success—and one of the most underestimated.",
    readTime: "6 min read",
    placeholder: true,
  },
];
